import { getAccessToken } from "../../auth/verifyAuth";

async function getProfile(msalInstance, variables) {
    try {
        const accessToken = await getAccessToken(msalInstance, variables);
        return fetch(window.location.origin + "/api/v2.0/profile", {
            method: "GET",
            headers: {
                "my-Authorization": `Bearer ${accessToken}`,
                "Accept": "application/json"
            }
        }).then(res => {
            if (res.ok) {
                return res.json()
            }
        });
    }
    catch (error) {
        console.error("Failed to get profile:", error);
        throw error;
    }
}

// // Met à jour le profil courant avec l'ensemble des propriétés éditées côté UI.
// async function patchProfile(msalInstance, variables, properties) {
//     const accessToken = await getAccessToken(msalInstance, variables);
//     return fetch(window.location.origin + "/api/v1.0/profile", {
//         method: "PATCH",
//         headers: {
//             "my-Authorization": `Bearer ${accessToken}`,
//             "Accept": "application/json",
//             "Content-Type": "application/json"
//         },
//         body: JSON.stringify(properties)
//     });
// }

export { getProfile };